module.exports = __webpack_public_path__ + "img/default.a9cb7dea.png";